export default class ImageObject
{

  constructor(url) {

    this.imageUrl = url;

    this.image = new Image();
    this.loaded = false;

    this.image.onload = () => {
      this.loaded = true;
    };

    this.image.onerror = (error) => {
      console.error("Loading image error", url, error);
      // remove on error handler, for in case the error image is unfindable as well
      this.image.onerror = () => {};
      this.image.src = globalVariables['missing_image'];
    };

    this.image.src = url;

  }

  getImage() {

    return this.image;

  }

  load() {

    return new Promise((resolve, reject) => {

      if (this.loaded) {
        resolve(this.image);
      }

      setInterval(() => {

        if (this.loaded) {
          resolve(this.image);
        }

      }, 100);

    });

  }

}
